// Confianza.jsx — sección "Confianza y seguridad", antes del FAQ.

import React from 'react'

function TrustBadge({ title, body, icon }) {
  return (
    <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
      <div
        style={{
          width: 44, height: 44, borderRadius: 10,
          background: "var(--accent-soft)",
          display: "grid", placeItems: "center",
          flexShrink: 0,
          color: "var(--gold)",
        }}
      >
        {icon}
      </div>
      <div>
        <div style={{ fontFamily: "var(--display)", fontSize: 18, textTransform: "uppercase", lineHeight: 1.05, marginBottom: 6 }}>{title}</div>
        <div style={{ fontSize: 13.5, color: "var(--fg-mute)", lineHeight: 1.55, maxWidth: 38 + "ch" }}>{body}</div>
      </div>
    </div>
  );
}

function Confianza() {
  const ICONS = {
    shield: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <path d="M12 2 L20 5 V12 C20 17 16 21 12 22 C8 21 4 17 4 12 V5 Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M9 12 L11 14 L15 10" stroke="currentColor" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    lock: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <rect x="5" y="10" width="14" height="11" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8 10 V7 a4 4 0 0 1 8 0 v3" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    ),
    eye: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <path d="M2 12 C5 6 9 5 12 5 S19 6 22 12 C19 18 15 19 12 19 S5 18 2 12 Z" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    ),
    receipt: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <path d="M6 3 H18 V21 L15 19 L12 21 L9 19 L6 21 Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <line x1="9" y1="9" x2="15" y2="9" stroke="currentColor" strokeWidth="1.8" />
        <line x1="9" y1="13" x2="15" y2="13" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    ),
  };

  return (
    <section id="confianza" style={{ background: "var(--bg-sunken)", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" }}>
      <div className="wrap">
        <div className="section-head fade-up">
          <div className="eyebrow">Confianza y seguridad</div>
          <h2 className="h-section" style={{ marginTop: 14 }}>
            Tu aporte llega <em>seguro</em>
          </h2>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: 28,
            marginBottom: 40,
          }}
          className="hero-grid"
        >
          <TrustBadge
            icon={ICONS.lock}
            title="Pago encriptado"
            body="Las transacciones se procesan a través de pasarelas de pago seguras. Tu tarjeta nunca pasa por nuestros servidores: viaja directamente a la pasarela bajo HTTPS y certificado SSL premium"
          />
          <TrustBadge
            icon={ICONS.eye}
            title="Cuenta exclusiva"
            body="Todos los aportes ingresan a una cuenta exclusiva del proyecto, separada del presupuesto general del Cuerpo de Bomberos de Quilpué. Tu aporte llega íntegro para esta campaña."
          />
          <TrustBadge
            icon={ICONS.shield}
            title="Datos protegidos"
            body="Tus Datos Personales están protegidos. Tu información solo se usa para los fines declarados de la campaña."
          />

          <TrustBadge
            icon={ICONS.receipt}
            title="Beneficio tributario"
            body="Los Cuerpos de Bomberos están incluidos como donatarios elegibles bajo la Ley N° 21.440. Las empresas pueden descontar hasta el 10% del aporte como gasto de su renta líquida imponible. El certificado se tramita con el Cuerpo de Bomberos luego de la donación si lo estiman conveniente."
          />
        </div>
      </div>
    </section>
  );
}

export { Confianza };
